import React from 'react';
import clsx from 'clsx';

import { getFormattedTime } from './utils';
import { useTimer } from '../../hooks';

interface ClockProps {
  label?: string;
  time: number | Date;
  formatType?: 'hh:mm:ss' | 'h[h] mm[m]' | 'HH:mm';
  className?: string;
  timeClassName?: string;
  labelClassName?: string;
  onComplete?: () => void;
}

export const Clock: React.FC<ClockProps> = ({
  label = 'Time Left',
  time,
  formatType = 'hh:mm:ss',
  className = 'text-small',
  onComplete,
  timeClassName = 'text-white',
  labelClassName = 'text-tiny font-normal',
}) => {
  const { remainingTime } = useTimer(time, onComplete);

  return (
    <div className={clsx('flex items-center gap-2', className)}>
      {!!label && (
        <span className={clsx('inline', labelClassName)}>{label}:</span>
      )}
      <span className={clsx(timeClassName, 'px-2')}>
        {getFormattedTime(remainingTime, formatType)}
      </span>
    </div>
  );
};
